import React, { useState } from 'react';
import { Dumbbell, Users, RefreshCw, Megaphone, Zap, DollarSign, FileText, CreditCard, Smartphone } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import AudienceLayout from './AudienceLayout';
import RegistrationModal from '../../components/RegistrationModal';

const ExtraFinancial = () => (
  <section className="py-16 px-4 sm:px-6 lg:px-12 bg-slate-50" data-testid="for-gym-financial">
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-10">
        <p className="text-sm font-bold uppercase tracking-widest text-orange-500 mb-2">TRANSPARÊNCIA</p>
        <h2 className="text-3xl sm:text-4xl font-black text-slate-900" style={{ fontFamily: 'Chivo, sans-serif' }}>Modelo Financeiro</h2>
      </div>
      <Card className="border-orange-200 shadow-lg overflow-hidden">
        <CardContent className="p-6 sm:p-8">
          <p className="text-slate-700 leading-relaxed mb-5">
            A academia recebe <strong className="text-orange-600">70% do plano vinculado ao aluno</strong>. Os outros <strong>30%</strong> permanecem em <em>reserva</em> para pagamento de check-ins em outras academias da rede.
          </p>
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
            <p className="text-sm text-emerald-800 leading-relaxed">
              <strong>Se o aluno utilizar apenas a sua academia</strong>, ao final do período <strong>a reserva retorna integralmente</strong> — você pode receber até <strong className="text-emerald-700">100% do valor</strong> conforme regras da plataforma.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  </section>
);

const ForGymPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <AudienceLayout
        color="orange"
        Icon={Dumbbell}
        eyebrow="VITAL PARA SUA ACADEMIA"
        title="Sua academia conectada a milhares de novos alunos."
        subtitle="A Vital Performance aproxima academias de empresas e pessoas, aumentando a ocupação e criando uma nova fonte recorrente de receita."
        heroImage="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80"
        onPrimary={() => setModalOpen(true)}
        onSecondary={() => document.querySelector('[data-testid="for-gym-how-it-works"]')?.scrollIntoView({ behavior: 'smooth' })}
        testIdPrefix="for-gym"
        steps={[
          { title: 'Academia faz o cadastro', desc: 'Preencha dados da unidade e responsável' },
          { title: 'Aguarda aprovação', desc: 'Verificação da nossa equipe' },
          { title: 'Define informações da unidade', desc: 'Modalidades, horários e fotos' },
          { title: 'Recebe alunos', desc: 'Vinculados via empresa ou individualmente' },
          { title: 'Realiza check-ins', desc: 'QR Code ou integração com catraca' },
          { title: 'Recebe repasses automáticos', desc: 'Depósito direto na conta cadastrada' },
        ]}
        benefits={[
          { icon: Users, title: 'Novos alunos', desc: 'Empresas locais + membros individuais' },
          { icon: RefreshCw, title: 'Receita recorrente', desc: 'Pagamentos mensais fixos' },
          { icon: Megaphone, title: 'Divulgação gratuita', desc: 'Sua academia na vitrine da plataforma' },
          { icon: Zap, title: 'Check-in inteligente', desc: 'App próprio ou catraca integrada' },
          { icon: DollarSign, title: 'Controle financeiro', desc: 'Painel com repasses em tempo real' },
          { icon: FileText, title: 'Relatórios completos', desc: 'Frequência e faturamento por aluno' },
          { icon: CreditCard, title: 'Pagamentos automáticos', desc: 'Sem atraso, sem negociação' },
          { icon: Smartphone, title: 'Gestão 100% digital', desc: 'Do celular ou desktop' },
        ]}
        extraSection={<ExtraFinancial />}
        finalCtaTitle="Amplie sua rede de alunos e sua receita."
        finalCtaSubtitle="Junte-se à rede Vital Performance e comece a receber alunos qualificados na sua unidade."
      />
      <RegistrationModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        initialProfile="gym"
      />
    </>
  );
};

export default ForGymPage;
